import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g id="Layer_15"><path d="M187.698,50.285l170.666,192c7.043,8.016 7.043,20.144 0,28.16l-170.666,192c-4.021,4.186 -9.581,6.555 -15.386,6.555c-11.703,0 -21.333,-9.63 -21.333,-21.333c0,-4.867 1.666,-9.591 4.719,-13.382l158.08,-177.92l-158.08,-177.92c-3.815,-3.972 -5.948,-9.271 -5.948,-14.778c0,-11.703 9.63,-21.333 21.333,-21.333c6.452,0 12.568,2.926 16.615,7.951Z" style="fill-rule:nonzero;"/></g></svg>`,
      }}
    />
  );
};
